export default {
    namespaced: false,
    state: {
        loading: false,
        loadingCount: 0,
    },
    getters: {
        loading(state) {
            return state.loadingCount > 0;
        }
    },
    mutations: {
        startLoading(state) {
            state.loadingCount++;
        },
        finishLoading(state) {
            if (state.loadingCount > 0)
                state.loadingCount--;
        }
    }
}